import { FFullMoment } from 'graphql/fragment/__generated__/FFullMoment';
import { DetailQuery_moment_cards } from 'graphql/query/__generated__/DetailQuery';
import { omitDeep } from 'libs/utils/object/objectOperations';
import _ from 'lodash';
import { PartialDeep } from 'type-fest';

import { CardInputWithType, StoryInput } from '__generated__/globalTypes';

export function getDetailInputFromDetail(moment: FFullMoment): StoryInput {
    return omitAnything(
        {
            header: moment.header,
            cardOrder: _.map(moment.cards, (card) => {
                return card.cardId;
            })
        } as StoryInput,
        ['__typename']
    );
}
export function omitAnything(obj: unknown, omits: string[]): unknown {
    return omitDeep(obj, omits);
}

export function getCardsInputFromCards(
    cards: DetailQuery_moment_cards[]
): PartialDeep<CardInputWithType>[] {
    return _.map(cards, (card) => {
        return omitAnything(card, ['__typename', 'containImage']);
    });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getCardsFromCardsInput(cards: PartialDeep<CardInputWithType>[]): any {
    return cards.map((card) => {
        return { ...card, __typename: 'Card' };
    });
}
